module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLogged) ? _c('topbar') : _vm._e(), _vm._v(" "), _c('top'), _vm._v(" "), _c('topmenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row columns"
  }, [(_vm.isFullSizePage === false) ? _c('div', [(_vm.showLeaguePanel) ? _c('div', {
    staticClass: "large-1 columns"
  }, [_c('leaguePanel')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "large-11 columns",
    class: {
      'large-centered': _vm.showLeaguePanel == false
    }
  }, [_c('router-view')], 1)]) : _c('div', [_c('div', {
    staticClass: "large-12 columns large-centered"
  }, [_c('router-view')], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713c381e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 768
// module chunks = 0